// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2QQVy","header":"ReportDetails_header__1kOvX","title":"ReportDetails_title__1ANv5","left":"ReportDetails_left__2CZKj"};